import { useState } from 'react';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import PropertySelectionObjectAgnosticPanel from 'automation-ui-canvas/create/trigger-prompts/PropertySelectionObjectAgnosticPanel';
import PropertySelectionObjectSpecificPanel from 'automation-ui-canvas/create/trigger-prompts/PropertySelectionObjectSpecificPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PropertySelectionPanel(props) {
  const [searchTerm, setSearchTerm] = useState('');
  const {
    objectTypeId
  } = props;
  if (objectTypeId === UNKNOWN_ID) {
    return /*#__PURE__*/_jsx(PropertySelectionObjectAgnosticPanel, Object.assign({}, props, {
      searchTerm: searchTerm,
      setSearchTerm: setSearchTerm
    }));
  } else {
    return /*#__PURE__*/_jsx(PropertySelectionObjectSpecificPanel, Object.assign({}, props, {
      searchTerm: searchTerm,
      setSearchTerm: setSearchTerm
    }));
  }
}